import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";

import { useIntl } from "react-intl";

import CoinsForm from "../forms/CoinsForm";

export function List() {
  const { formatMessage } = useIntl();
  const styles = {
    fontSize: '15px',
    color: 'var(--green)',
  };
  return (
    <>
      <Card>
        <CardHeader>
          <h2 className={"text-center py-5"}>
            {formatMessage({ id: "PURCHASE_COINS" })}
            <span> | </span>
            <span className="text- py-5" style={styles}>
              {formatMessage({ id: "PURCHASE_PROCESS" })}
            </span>
          </h2>

        </CardHeader>
        <CardBody>
          <CoinsForm />
        </CardBody>
      </Card>
    </>
  );
}
